module.exports = __webpack_public_path__ + "img/3.75c132b8.jpg";